// Login
export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST";
export const FETCH_LOGIN_SUCCESS = "FETCH_LOGIN_SUCCESS";
export const FETCH_LOGIN_FAIL = "FETCH_LOGIN_FAIL";
export const FETCH_EDIT_REQUEST = "FETCH_EDIT_REQUEST";
export const FETCH_EDIT_SUCCESS = "FETCH_EDIT_SUCCESS";
export const FETCH_EDIT_FAIL = "FETCH_EDIT_FAIL";

// Logout
export const FETCH_LOGOUT_REQUEST = "FETCH_LOGOUT_REQUEST";

// Language
export const FETCH_LANGUAGE_REQUEST = " FETCH_LANGUAGE_REQUEST";
export const FETCH_LANGUAGE_SUCCESS = " FETCH_LANGUAGE_SUCCESS";
export const FETCH_LANGUAGE_FAIL = " FETCH_LANGUAGE_FAIL";
export const FETCH_UPDATE_USER = "FETCH_UPDATE_USER";
//Forget Password
export const BACK = "BACK";
export const FETCH_FORGET_REQUEST = "FETCH_FORGET_REQUEST";
export const FETCH_FORGET_SUCCESS = "FETCH_FORGET_SUCCESS";
export const FETCH_FORGET_FAIL = "FETCH_FORGET_FAIL";

export const FETCH_CONFIRMATIONCODE_REQUEST = "FETCH_CONFIRMATIONCODE_REQUEST";
export const FETCH_CONFIRMATIONCODE_SUCCESS = "FETCH_CONFIRMATIONCODE_SUCCESS";
export const FETCH_CONFIRMATIONCODE_FAIL = "FETCH_CONFIRMATIONCODE_FAIL";
export const FETCH_UPDATE_ROLE = "FETCH_UPDATE_ROLE";
export const FETCH_Contact_Us_COUNT_Msg = "FETCH_Contact_Us_COUNT_Msg";
export const FETCH_RESETPASSWORD_REQUEST = "FETCH_RESETPASSWORD_REQUEST";
export const FETCH_RESETPASSWORD_SUCCESS = "FETCH_RESETPASSWORD_SUCCESS";
export const FETCH_RESETPASSWORD_FAIL = "FETCH_RESETPASSWORD_FAIL";

// Initialize USER
export const REINTIALIZE = "REINTIALIZE";

// Side Menu
export const SIDEMENUSTATUS = "SIDEMENUSTATUS";

// LAYOUT SETTING
export const COLORLAYOUT = "COLORLAYOUT";
export const COLORSIDEMENU = "COLORSIDEMENU";
export const BGSIDEMENU = "BGSIDEMENU";
// Sub Header
export const SUBHEADER = "SUBHEADER";

// Socket
export const FETCH_NEW_Message = "FETCH_NEW_Message";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const FETCH_TYPING = "FETCH_TYPING";
export const FETCH_STOP_TYPING = "FETCH_STOP_TYPING";
export const CLEAR_ISTYPING = "CLEAR_ISTYPING";
export const CLEAR_STOPTYPING = "CLEAR_STOPTYPING";
export const FETCH_UNSEENMESSAGES_COUNT = "FETCH_UNSEENMESSAGES_COUNT";

export const FETCH_CONTACT_US_COUNT = "FETCH_CONTACT_US_COUNT";
export const FETCH_TALENT_COUNT = "FETCH_TALENT_COUNT";
export const FETCH_Organization_COUNT = "FETCH_Organization_COUNT";
export const FETCH_Order_Talent_COUNT = "FETCH_Order_Talent_COUNT";
export const FETCH_New_Message = "FETCH_New_Message";
